import * as React from "react";
import { GlobalConnectedProps, withVariableLookup } from "components/form/VariableLookup/VariableLookup";
import AutoComplete, { AutoCompleteProps } from "components/AutoComplete/AutoComplete";

const AutoCompleteWithInputRef = (props: AutoCompleteProps & GlobalConnectedProps) => <AutoComplete {...props} />;
export const VariableLookupAutoComplete = withVariableLookup()(AutoCompleteWithInputRef);
